<template>
  <v-container>
    <material-card elevation="5">
      <v-layout px-3 slot="header">
        <v-flex mt-2 pl-3 align-center justify-center>
          <div class="headline pt-3 pb-4">Konfiguracja</div>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-list>
            <check-permission v-for="(link, index) in links" :key="index" :permissions="link.permission">
              <v-list-tile :to="link.to">
                <v-list-tile-action>
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ link.text }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </check-permission>
          </v-list>
        </v-flex>
      </v-layout>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/material/Card';

// @vuese
// Podsumowanie
// @group Dashboard
export default {
  components: {
    MaterialCard
  },
  data() {
    return {
      links: [
        {
          icon: 'mdi-bank',
          to: { name: 'collectionPoints' },
          text: 'Punkty odbioru',
          permission: ['COLLECTION_POINT.LIST']
        },
        { icon: 'mdi-account-group', to: { name: 'groups' }, text: 'Grupy', permission: ['GROUP.LIST'] },
        { icon: 'mdi-settings', to: { name: 'settings' }, text: 'Ustawienia', permission: ['SETTING.LIST'] },
        { icon: 'mdi-sitemap', to: { name: 'roles' }, text: 'Role', permission: ['ROLE.LIST'] },
        { icon: 'mdi-email', to: { name: 'templates' }, text: 'Szablony', permission: ['MAIL_TEMPLATE.LIST'] },
        { icon: 'mdi-pound', to: { name: 'categories' }, text: 'Kategorie' },
        { icon: 'mdi-clipboard-text', to: { name: 'terms' }, text: 'Regulaminy', permission: ['TERMS.LIST'] },
        { icon: 'mdi-desktop-mac-dashboard', to: { name: 'pages' }, text: 'Strony', permission: ['PAGE.LIST'] }
      ]
    };
  }
};
</script>
